import { api } from '../../DefaultService';
import {
  ITemperatureDetectorDeviceCreateProps,
  ITemperatureDetectorDeviceFilterProps,
  ITemperatureDetectorDeviceProps,
  ITemperatureDetectorDeviceSimpleProps,
  ITemperatureDetectorDeviceUpdateParams,
} from './types';
import { IPaginationParams } from '../../types';

const ENDPOINT = 'v1/devices/cameras/temperatureDetector';

export const createTemperatureDetectorDeviceAsync = async (
  data: ITemperatureDetectorDeviceCreateProps,
): Promise<ITemperatureDetectorDeviceProps> => {
  return await api
    .post(ENDPOINT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getTemperatureDetectorDeviceByIdAsync = async (
  id: number,
): Promise<ITemperatureDetectorDeviceProps> => {
  return await api
    .get(`${ENDPOINT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllTemperatureDetectorDeviceByLicenseAsync = async (
  pagination: IPaginationParams,
  filter: ITemperatureDetectorDeviceFilterProps,
): Promise<ITemperatureDetectorDeviceSimpleProps[]> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense`, {
      params: { ...pagination, ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllTemperatureDetectorDeviceCountByLicenseAsync = async (
  filter: ITemperatureDetectorDeviceFilterProps,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT}/getAllByLicense/count`, {
      params: { ...filter },
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateTemperatureDetectorDeviceAsync = async ({
  id,
  data,
}: ITemperatureDetectorDeviceUpdateParams): Promise<ITemperatureDetectorDeviceProps> => {
  return await api
    .put(`${ENDPOINT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const deleteTemperatureDetectorDeviceAsync = async (
  id: number,
): Promise<void> => {
  await api.delete(`${ENDPOINT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};
